import { useState, useEffect, useRef } from "react"
import { Link, useNavigate, useParams, useLocation } from "react-router-dom"
import {
  IconAlertCircle,
  IconArrowLeft,
} from "../../components/utils/Icons/CustomIcons"
import {
  clearQrId,
  copyEvent,
  getEvent,
  getEventByHash,
} from "../../redux/slices/events/eventsSlice"
import { authentication } from "@/redux/slices/auth/authSlice"
import { getBalance } from "@/redux/slices/balance/balanceSlice"
import api from "@/api/api"
import { Image, Button } from "react-bootstrap"
import { t } from "i18next"
import { MdEdit, MdOutlineGrading } from "react-icons/md"
import { ToastContainer, toast, Slide } from "react-toastify"
import { useAppDispatch, useAppSelector } from "@/redux/store"
import { useTranslation } from "react-i18next"
import weddingImage from "@/assets/images/weddingImage.png"
import { RiDeleteBin6Line } from "react-icons/ri"
import { MdLocalPhone } from "react-icons/md"
import { BiSave } from "react-icons/bi"
import { IoMdAdd } from "react-icons/io"
import { IoChevronBack } from "react-icons/io5"
import Modal from "react-bootstrap/Modal"
import Carousel from "react-bootstrap/Carousel"
import chooseTypeNumber from "@/assets/images/chooseType.png"
import chooseTypeName from "@/assets/images/chooseTypeName.png"
import { BsFillPatchCheckFill } from "react-icons/bs"
import Spinner from "react-bootstrap/Spinner"
import invitesmart from "@/assets/images/invitesmart.svg" // Adjust the path as necessary
import { IoMdClose } from "react-icons/io"
import { MdQrCodeScanner } from "react-icons/md"
import { CiSearch } from "react-icons/ci"
import { IoMdCheckmark } from "react-icons/io"
import { PaginationControl } from "react-bootstrap-pagination-control"
import { LuDownload } from "react-icons/lu"
import Paginator from "../../components/utils/Pagination/Pagination"
import "bootstrap/dist/css/bootstrap.min.css" // Ensure Bootstrap is imported
import DownloadSingleImage from "./DownloadSingleImage"
import DownloadSingleImageSmaller from "./DownloadSingleImageSmaller"
import DownloadAllImages from "./DownloadAllImages"
import DownloadAllImagesSmaller from "./DownloadAllImagesSmaller"
import ResponsiveImageWithQRCode from "./ResponsiveImageWithQRCode"
import ResponsiveImageWithQRCodeSmaller from "./ResponsiveImageWithQRCodeSmall"
import { IoIosClose } from "react-icons/io"

const findLatestEntitlement = (entitlements: any) => {
  const now = new Date() // Current date and time
  const entitlementList = Object.values(entitlements)
  // Filter entitlements to only include those that have not expired
  const activeEntitlements = entitlementList.filter((entitlement: any) => {
    return new Date(entitlement.expires_date) > now
  })

  // If no active entitlements, return null or handle appropriately
  if (activeEntitlements.length === 0) return null

  // Find the latest entitlement based on purchase_date
  return activeEntitlements.reduce((latest: any, current: any) => {
    return new Date(current.purchase_date) > new Date(latest.purchase_date)
      ? current
      : latest
  })
}
const InviteDetail = () => {
  const { t } = useTranslation()

  const { event_id } = useParams()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [showPremium, setShowPremium] = useState(true)
  const location = useLocation()
  ///// type of the current added guests type
  const [currentAddTye, setCurrentAddType] = useState("name")

  const { isLoading, open_hash, is_open_event } = useAppSelector(
    (state) => state.events,
  )
  const [loadingDownload, setLoadingDownload] = useState(false)
  // const { current_page, total_pages } = useAppSelector(
  //   (state) => state.contacts,
  // )
  //
  const downloadRefSelected = useRef<any>(null)
  const handleSaveAll = () => {
    setLoadingDownload(true)

    if (downloadRef.current) {
      downloadRef.current.downloadImages()
    }
    setLoadingDownload(false)
  }

  const handleBack = () => {
    if (location.state?.from === "/add-invite") {
      navigate("/") // Redirect to home if coming from "/add-invite"
    } else {
      navigate(-1) // Redirect to the previous page as it is
    }
  }
  const handleSaveAllSelected = () => {
    if (downloadRefSelected.current) {
      downloadRefSelected.current.downloadImages()
    }
  }

  const { email, phone, first_name, last_name } = useAppSelector(
    (state) => state?.auth,
  )
  const [loadingPremium, setLoadingPremium] = useState(false)
  const [premium, setPremium] = useState(0)

  const [currentContactId, setCurrentContactId] = useState<any>(null)
  const [showUpdateModal, setShowUpdateModal] = useState(false)
  const [showCreateModal, setShowCreateModal] = useState(false)
  const event = useAppSelector((state) => state.events.currentEvent)

  //contacts list
  const [enableSelect, setEnableSelect] = useState(false)
  const [contacts, setContacts] = useState<any>(null)
  const [contactsPagination, setContactsPaginatio] = useState()
  const [limit, setLimit] = useState(20)
  const [loadingContacts, setLoadingContacts] = useState(false)

  const [contactsValue, setContactsValue] = useState({
    currentPage: 1, // Default value for currentPage
    totalPages: 1,
    limit: 20, // Default value for limit
    searchValue: "", // Default value for searchValue
  })
  /////
  const [qrCodeData, setQrCodeData] = useState<any>(null)
  const [loading, setLoading] = useState(true)
  const [addingGuestLoading, setAddingGuestLoading] = useState(false)
  const [displayImage, setDisplayImage] = useState(false)
  const [currentContact, setCurrentContact] = useState<any>(null)
  const [referesh, setRefresh] = useState(false)
  const [namesInput, setNamesInput] = useState<string>("")
  //edit contact
  const [guestEdit, setGuestEdit] = useState("")
  const [showEditContact, setShowEditContact] = useState(false)
  const [loadingEditGuest, setLoadingEditGuest] = useState(false)

  ///
  const [subscription, setSubscription] = useState("basic_plan")
  ////
  const [isTabActive, setIsTabActive] = useState(true)

  // add guests
  const [addGuestType, setAddGuestType] = useState("")
  const [nextStep, setNextStep] = useState(0)

  ////download invites
  const [showDownloadInvites, setShowDownloadInvites] = useState(false)
  const [showDownloadInvitesSingle, setShowDownloadInvitesSingle] =
    useState(false)

  //////
  const [selectedContacts, setSelectedContacts] = useState<any>([])
  const downloadRef = useRef<any>(null)
  const triggerDownload = () => {
    if (downloadRef.current) {
      downloadRef.current.downloadInvites()
    }
  }
  // Handle selecting/deselecting a contact
  const handleSelectContact = (contact: any) => {
    setSelectedContacts((prevSelectedContacts: any) => {
      // Check if the contact is already selected by comparing the contact id
      const isSelected = prevSelectedContacts.some(
        (selectedContact: any) => selectedContact.id === contact.id,
      )

      if (isSelected) {
        // If contact is already selected, remove it from the list
        return prevSelectedContacts.filter(
          (selectedContact: any) => selectedContact.id !== contact.id,
        )
      } else {
        // Otherwise, add the whole contact object to the list
        return [...prevSelectedContacts, contact]
      }
    })
  }

  // Handle registering selected contacts (you can adjust this to your needs)
  const handleRegisterSelectedContacts = () => {
    // Your registration logic here
  }

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        setIsTabActive(true) // User returned to the tab
      } else {
        setIsTabActive(false) // User left the tab
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [])

  ////control name and number slide
  const [index, setIndex] = useState(0)

  const handleSelect = (selectedIndex: any) => {
    setIndex(selectedIndex)
  }

  ////select
  const images = [chooseTypeName, chooseTypeNumber] // Add more if needed
  const [selectedImage, setSelectedImage] = useState(0)
  const handleScroll = (e: any) => {
    const scrollLeft = e.target.scrollLeft
    const currentIndex = Math.round(scrollLeft / e.target.clientWidth)
    setSelectedImage(currentIndex)
  }

  /////
  const [numberOfGuests, setNumberOfGuests] = useState<any>("")
  const [showDeleteContact, setShowDeleteContact] = useState(false)
  const [loadingDeleteContact, setLoadingDeleteContact] = useState(false)
  const [showDeleteEvent, setShowDeleteEvent] = useState(false)
  const [loadingDeleteEvent, setLoadingDeleteEvent] = useState(false)

  const handleCloseDeleteContact = () => {
    setShowDeleteContact(false)
  }
  const handleCloseDeleteEvent = () => {
    setShowDeleteEvent(false)
  }

  const handleCloseDownloadInvites = () => {
    setShowDownloadInvites(false)
  }

  const [currentContactSingle, setCurrentContactSingle] = useState<any[]>([])

  //./////download single
  const handleCloseDownloadInvitesSingle = () => {
    setShowDownloadInvitesSingle(false)
  }

  const handleDownLoadSingle = (data: any) => {
    setShowDownloadInvitesSingle(true)
    setCurrentContactSingle([data])
  }

  const handleDeleteContact = (data: any) => {
    setShowDeleteContact(true)
    setCurrentContact(data)
  }

  const handleDeleteEvent = () => {
    setShowDeleteEvent(true)
  }

  const handleCloseDisplayImage = () => {
    setDisplayImage(false)
  }
  const handleDisplayImage = (data: any) => {
    setDisplayImage(true)
    setCurrentContact(data)
  }
  const handleCloseEditContact = () => {
    setShowEditContact(false)
  }

  const handleEditContact = (data: any) => {
    setCurrentContact(data)
    setGuestEdit(data?.first_name)

    setShowEditContact(true)
  }

  const handleCloseUpdateModal = () => {
    setShowUpdateModal(true)
  }
  const handleCloseCreateModal = () => {
    setShowCreateModal(false)
  }

  const addCard = async () => {
    setShowCreateModal(true)
  }

  useEffect(() => {
    try {
      setLoading(true)
      dispatch(getEvent(Number(event_id))).then(async (res: any) => {
        // qr_code_design_id

        if (res?.payload?.data?.isPremium == 1) {
          setPremium(1)
        }
        try {
          const qrCodeData = await api.events.getQrDesign(
            parseInt(res?.payload?.data?.qr_code_design_id),
          )
          setQrCodeData(qrCodeData?.data?.data)
        } catch (err) {
          setLoading(false)
        }

        open_hash !== null &&
          is_open_event === 1 &&
          dispatch(getEventByHash(open_hash))
        setLoading(false)
      })
    } catch {
      setLoading(false)

      toast.error("Error while fetching the event")
    }
  }, [dispatch, event_id, open_hash, is_open_event])
  const onPageChanged = (page: number) => {
    setContactsValue((prev) => ({
      ...prev,
      // totalPages: Math.ceil(contacts?.meta?.data?.pagination?.totalPages),
      currentPage: page, // Reset to page 1 when limit changes
    }))
  }

  useEffect(() => {
    const data = {
      id: Number(event_id),
      currentPage: contactsValue?.currentPage,
      limit: contactsValue?.limit,
      searchValue: contactsValue?.searchValue,
      statusNumber: "",
    }
    try {
      setLoadingContacts(true)
      const fetchContacts = async () => {
        const contacts: any = await api.contacts.getContactsOnEventN(data)
        setContacts(contacts?.data?.data)

        setContactsValue((prev) => ({
          ...prev,
          totalPages: Math.ceil(contacts?.data?.meta?.pagination?.total_pages),
          // currentPage: 1, // Reset to page 1 when limit changes
        }))

        setLoadingContacts(false)
      }
      fetchContacts()
      // setLoadingContacts(false)
    } catch {
      setLoadingContacts(false)
    }
  }, [contactsValue?.currentPage, contactsValue?.searchValue, referesh])

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const identifier = email || phone || ""
        const res = await api.payments.getPovSubscription(identifier)
        const plan: any = findLatestEntitlement(
          res?.data.subscriber?.entitlements,
        )
        setSubscription(plan?.product_identifier)

        if (
          plan?.product_identifier == "pro_plan" ||
          plan?.product_identifier == "unlimited_plan"
        ) {
          setPremium(1)
        } else {
          // setPremium(0)
        }
      } catch (error) {}
    }

    fetchSubscription()
  }, [email, phone])

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        dispatch(authentication(null))
          .then((data) => {
            if (
              data?.payload?.invitesmart_subscription &&
              data?.payload?.invitesmart_subscription != "basic"
            ) {
              setPremium(1)
            }
          })
          .catch((error) => {})
      } catch (error) {
        console.error("Error fetching subscription:", error)
      }
    }

    fetchSubscription()
  }, [])
  const handleSubmitFormNaming = async (e: any) => {
    e.preventDefault()
    try {
      setAddingGuestLoading(true)
      let formattedNames: any = []
      // nextStep
      if (contacts && contacts.length > 0) {
        let startingPhoneNumber =
          Math.floor(100000 + Math.random() * 900000) * 100 // Ends with '00'
        const firstContact = contacts[contacts.length - 1]
        // Ensure firstContact.phone is a string before processing
        let basePhoneNumber =
          typeof firstContact.last_name === "string"
            ? parseInt(firstContact.last_name.replace(/\D/g, ""), 10)
            : NaN
        if (isNaN(basePhoneNumber) || basePhoneNumber.toString().length !== 8) {
          // Generate a random 8-digit number ending in "00"
          basePhoneNumber = Math.floor(100000 + Math.random() * 9000) * 100
        }
        const namesArray = namesInput
          .split(/\s*[,;|\n]\s*/g) // Split by comma, semicolon, or new line, allowing optional spaces
          .map((name) => name.trim())
          .filter((name) => name !== "") // Filter out any empty names

        formattedNames = namesArray.map((name: any, index: number) => ({
          first_name: name ? name : "",
          last_name: `${basePhoneNumber + index}`,
          suffix: "Mr",
          email: "",
          // phone: name,
          phone: (startingPhoneNumber + index).toString(), // Increment the phone number
          quantity_members: "1",
        }))
      } else {
        const basePhoneNumber = Math.floor(100000 + Math.random() * 9000) * 100
        const namesArray = namesInput
          .split(/\s*[,;|\n]\s*/g) // Split by comma, semicolon, or new line, allowing optional spaces
          .map((name) => name.trim())
          .filter((name) => name !== "") // Filter out any empty names

        formattedNames = namesArray.map((name: any, index: number) => ({
          first_name: name ? name : "",
          last_name: `${basePhoneNumber + index}`,
          suffix: "Mr",
          email: "",
          // phone: name,
          phone: (basePhoneNumber + index).toString(), // Increment the phone number
          quantity_members: "1",
        }))
      }
      const totalData = {
        event_id: event?.event_id,
        contacts: formattedNames,
      }
      const contactAdded: any = await api?.contacts?.addGuest(totalData)
      if (contactAdded?.status == 200) {
        setAddingGuestLoading(false)
        setShowCreateModal(false)

        setRefresh(!referesh)
        setNamesInput("")

        toast.success("Guest added  successfully")
        dispatch(getBalance()).then((data) => {})
      } else {
        toast.error(
          contactAdded?.data?.message
            ? contactAdded?.data?.message
            : "Guest adding error , try gain later please",
        )
        setShowCreateModal(false)
      }

      // toast.success("Event update successfully")

      // setActivePage("addNames")
    } catch (err: any) {
      setAddingGuestLoading(false)
      setShowCreateModal(false)

      const message = err?.response?.data?.message
        ? err?.response?.data?.message
        : "Error while adding contacts , try gain later please"

      toast.error(message)
    }
  }
  const handleSubmitFormNumber = async (e: any) => {
    e.preventDefault()
    if (numberOfGuests < 1) {
      alert("Please enter a valid number of guests greater than or equal to 1.")
      return // Exit the function if validation fails
    }

    try {
      setAddingGuestLoading(true)
      setCurrentAddType("name")

      const generateRandomPhone = () => {
        const randomPart = Math.floor(100000 + Math.random() * 900000) // Generate a 6-digit number
        return `${randomPart}00` // Append "00" to make it an 8-digit number
      }

      let formattedNames = []

      // if (contacts && contacts.length > 0) {
      //   // Use the last contact as a reference
      //   const lastContact = contacts[contacts.length - 1]
      //   const basePhoneNumber = parseInt(
      //     lastContact.phone.replace(/\D/g, ""),
      //     10,
      //   )

      //   // Extract numeric part of phone number
      //   formattedNames = Array.from({ length: numberOfGuests }, (_, index) => ({
      //     first_name: `${basePhoneNumber + index + 1}`,
      //     last_name: lastContact.last_name || "",
      //     suffix: lastContact.suffix || "Mr",
      //     email: "",
      //     phone: `${basePhoneNumber + index + 1}`, // Increment phone number
      //     quantity_members: "1",
      //   }))
      // }
      if (contacts && contacts.length > 0) {
        // Use the last contact as a reference
        const firstContact = contacts[contacts.length - 1]
        // Ensure firstContact.phone is a string before processing
        let basePhoneNumber =
          typeof firstContact.last_name === "string"
            ? parseInt(firstContact.last_name.replace(/\D/g, ""), 10)
            : NaN
        if (isNaN(basePhoneNumber) || basePhoneNumber.toString().length !== 8) {
          // Generate a random 8-digit number ending in "00"
          basePhoneNumber = Math.floor(100000 + Math.random() * 9000) * 100
        }
        // Generate formatted names with incremented phone numbers
        formattedNames = Array.from({ length: numberOfGuests }, (_, index) => ({
          first_name: `${basePhoneNumber + index + 1}`,
          last_name: `${basePhoneNumber + index + 1}`,
          suffix: firstContact.suffix || "Mr",
          email: "",
          phone: `${basePhoneNumber + index + 1}`, // Increment phone number
          quantity_members: "1",
        }))
      } else {
        const generateRandomPhoneBase = (): number => {
          // Generate a random 6-digit number and append "00" to make it an 8-digit number ending in "00"
          return Math.floor(100000 + Math.random() * 900000) * 100
        }
        const generateFormattedNames = (numberOfGuests: number): any[] => {
          // Generate the initial random phone number
          const initialPhoneNumber = generateRandomPhoneBase()

          // Create formatted names with incremented phone numbers
          return Array.from({ length: numberOfGuests }, (_, index) => {
            const phoneNumber = (initialPhoneNumber + index)
              .toString()
              .padStart(8, "0") // Increment phone number by 1 and ensure it's 8 digits
            return {
              first_name: phoneNumber, // Example guest name, can be replaced with actual names
              last_name: phoneNumber,
              suffix: "Mr",
              email: "", // Example email, can be replaced
              phone: phoneNumber,
              quantity_members: "1",
            }
          })
        }
        formattedNames = generateFormattedNames(numberOfGuests)
      }

      // Prepare totalData
      const totalData = {
        event_id: event_id,
        contacts: formattedNames,
      }
      // Make API call
      const contactAdded: any = await api?.contacts?.addGuest(totalData)

      if (contactAdded?.status == 200) {
        setShowCreateModal(false)
        setRefresh(!referesh)
        toast.success("Guest added successfully")
        dispatch(getBalance())
      } else {
        setShowCreateModal(false)
        const errorMessage =
          contactAdded?.data?.message ||
          "Error while adding guests, please try again later."
        toast.error(errorMessage)
        setAddingGuestLoading(false)
      }
    } catch (err: any) {
      console.log("err-err", err)
      setShowCreateModal(false)
      const message = err?.response?.data?.message
        ? err?.response?.data?.message
        : "Error while adding contacts , try gain later please"

      setAddingGuestLoading(false)
      toast.error(message)
    } finally {
      setShowCreateModal(false)

      setAddingGuestLoading(false)
    }
  }

  const handleSubmitDeleteEvent = async () => {
    setLoadingDeleteEvent(true)
    try {
      const deleteEvent = await api.events.deleteEvent(
        event?.event_id ? event?.event_id : "",
      )
      if (deleteEvent) {
        setLoadingDeleteEvent(false)
        // setShowDeleteContact(false)
        toast.success("Event deleted successfully")
        setShowDeleteEvent(false)
        dispatch(getBalance())

        setTimeout(() => {
          navigate("/")
        }, 1000)
      } else {
        setShowDeleteEvent(false)
        toast.error("Event Not deleted ")
      }
    } catch (err: any) {
      setLoadingDeleteEvent(false)
      setShowDeleteEvent(false)

      // setShowDeleteContact(false)
      toast.error("Error while deleting card ")
    }
  }

  const handleSubmitDeleteContact = async () => {
    setLoadingDeleteContact(true)
    try {
      // dispatch(
      //   deleteGuest({
      //     eventId: event?.event_id,
      //     guestId: [{ contact_id: currentContact?.id }],
      //   }),
      // ).then((result: any) => {

      // })
      const params = {
        eventId: event?.event_id,
        contactId: currentContact?.id,
      }
      const deleteGuests = await api.contacts.deleteGuestNew(params)
      if (deleteGuests?.status == 200 || deleteGuests?.status == 202) {
        setLoadingDeleteContact(false)
        // setShowDeleteContact(false)
        setShowDeleteContact(false)

        toast.success("Guest deleted successfully")
        dispatch(getBalance())

        setContacts(
          contacts.filter((contact: any) => contact.id !== currentContact?.id),
        )
      } else {
        setLoadingDeleteContact(false)

        toast.error("Guest not deleted ")
      }
    } catch (err: any) {
      setLoadingDeleteContact(false)
      setShowDeleteContact(false)

      // setShowDeleteContact(false)
      toast.error("Error while deleting event ")
    }
  }

  const handleSubmitEdit = async (e: any) => {
    e.preventDefault()
    setLoadingEditGuest(true)
    try {
      const params = {
        id: currentContact?.id,
        // phone: guestEdit,
        first_name: guestEdit,
      }

      // let startingPhoneNumber =
      // Math.floor(100000 + Math.random() * 900000) * 100 // Ends with '00'
      const editContact = await api.contacts.updateContact(params)

      if (editContact?.status == 200) {
        setLoadingEditGuest(false)
        // setShowDeleteContact(false)
        toast.success("Guest edited successfully")
        setShowEditContact(false)
        setRefresh(!referesh)
      } else {
        setShowEditContact(false)
        toast.error("Guest not edited")
      }
    } catch (err: any) {
      setLoadingEditGuest(false)
      setShowEditContact(false)
      const message = err?.response?.data?.message
        ? err?.response?.data?.message
        : "Error while editing guest"

      toast.error(message)
      // setShowDeleteContact(false)
    }
  }
  useEffect(() => {
    const checkEventStatus = async (eventId: string | number) => {
      try {
        const res = await api.events.checkEventStatus(eventId)
        if (
          premium == 0 &&
          res?.data?.isPremium == 1 &&
          event !== null &&
          event &&
          event?.isPremium != 1
        ) {
          toast.success("Event upgraded successfully", {
            position: "top-right",
            transition: Slide,
            autoClose: 2000, // 3 seconds
            closeButton: false, // Removes the close button
          })
          if (res?.data?.isPremium == 1) setPremium(1)
        } else {
          // setPremium(res?.data?.isPremium)
        }
      } catch (error) {}
    }
    if (event && event !== null) checkEventStatus(event?.event_id)
  }, [isTabActive])
  const handleSaveInvite = async () => {
    setLoadingPremium(true)

    let currentEvent: any = {}
    try {
      const body = {
        priceId: "price_1QRqNQCykVN8e2WmnN20XvWi",
        successUrl: "https://dev-api.mazoom.sa/api/stripe/payment/success",
        mode: "payment",
        eventId: event?.event_id,
        txnType: "invitationUpgrade",
      }

      const response = await api.events.subscribeForEvent(body)

      if (response?.status) {
        setLoadingPremium(false)

        const url = response?.data?.checkout_url

        if (url) {
          setLoadingPremium(false)

          // handleCloseUpgrade()
          window.open(url, "_blank")
          // window.location.href = url
        } else {
          setLoadingPremium(false)

          toast.error("Something went wrong: Invalid URL", {
            position: "top-right",
            transition: Slide,
            autoClose: 2000, // 3 seconds
            closeButton: false, // Removes the close button
          })
        }
      } else {
        setLoadingPremium(false)

        toast.error("Something went wrong: Response status not OK", {
          position: "top-right",
          transition: Slide,
          autoClose: 2000, // 3 seconds
          closeButton: false, // Removes the close button
        })
      }
    } catch (error) {
      console.log("error-error-error", error)
      setLoading(false)
      toast.error("Something went wrong: Response status not OK", {
        position: "top-right",
        transition: Slide,
        autoClose: 2000, // 3 seconds
        closeButton: false, // Removes the close button
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="container" style={{ minHeight: "100vh" }}>
      {" "}
      <div className="">
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          >
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <>
            {event ? (
              <>
                <div className="mb-2 p-0 " style={{ width: "80px" }}>
                  <Button
                    className="d-flex align-items-center "
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      color: "black",
                      fontSize: "18px",
                      textDecoration: "none",
                      textTransform: "none",
                    }}
                    onClick={handleBack}
                  >
                    <IconArrowLeft />
                    <span className="reminders-page__link-text me-2">
                      {t("buttons.backNew")}
                    </span>
                  </Button>
                </div>{" "}
                <div className="mt-4 ms-0 ms-md-">
                  <div className="d-flex flex-row gap-0 m-0 p-0  align-items-start justify-content-between ">
                    <div className="m-0 p-0 gap-0">
                      {" "}
                      <h6
                        className="fs-3 fw-bold m-0 p-0 d-flex flex-wrap"
                        style={{
                          color: "#245192",
                          // maxWidth: "100px",
                          // wordWrap: "break-word",
                        }}
                      >
                        {event?.name}{" "}
                      </h6>{" "}
                      {/* <span
                        className="text-muted d-block  "
                        style={{ fontSize: "15px" }}
                      >
                        {" "}
                        {t("invitation.inviteName")}{" "}
                      </span> */}
                    </div>

                    <div className="d-flex gap-2">
                      <button
                        className="btn btn "
                        style={{
                          backgroundColor: "#245192",
                          borderRadius: "",
                          height: "40px",
                          // width: "45px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: "9px",
                          cursor: "pointer",
                          border: "1px solid #e8e5e5",
                          color: "#ffffff",
                        }}
                        onClick={() => {
                          navigate(`/invite-edit/${Number(event_id)}`)
                        }}
                      >
                        <MdEdit
                          style={{
                            color: "#ffffff",
                            marginRight: "6px",
                            marginLeft: "6px",
                          }}
                        />{" "}
                        {t("buttons.edit")}{" "}
                      </button>
                      <button
                        className="btn btn fw-semibold"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "",
                          height: "40px",
                          // width: "45px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: "9px",
                          cursor: "pointer",
                          border: "1px solid #e8e5e5",
                          color: "#e40202",
                        }}
                        onClick={handleDeleteEvent}
                      >
                        <RiDeleteBin6Line
                          style={{
                            color: "#e40202",
                            marginRight: "6px",
                            marginLeft: "6px",
                          }}
                          onClick={handleDeleteEvent}
                        />
                        {t("buttons.delete")}{" "}
                      </button>
                    </div>
                  </div>

                  <div
                    className="mt-4 mb-4  "
                    // style={{ backgroundColor: "#ffffff" }}
                  >
                    {/* {contacts?.length > 0 && ( */}
                    <div
                    // className="d-flex justify-content-between align-items-center"
                    >
                      <div
                        className="w-100 row  mb-4 me-4  pt-4 pb-0  gap-0  "
                        style={{
                          height: "auto",
                          backgroundColor: "#ffffff",
                        }}
                      >
                        <div
                          className="col-12 col-sm-4 mt-3  col-md-4  col-lg-3 mb-3 "
                          // style={{ backgroundColor: "yellow" }}
                        >
                          <h5
                            className="mt-0 fw-semibold "
                            style={{
                              fontSize: "1.3rem",
                              // color: "#20529B",
                              // marginTop: "10px",
                            }}
                          >
                            {t("inviteDetail.guests")}
                          </h5>
                        </div>
                        <div className="col-12 col-sm-8 col-md-8 col-lg-4 position-relative mb-3 mt-3">
                          {/* Input Field */}
                          <input
                            type="text"
                            className="form-control pe-5"
                            placeholder={t("invitation.searchGuests")}
                            value={contactsValue?.searchValue}
                            onChange={(e: any) => {
                              setContactsValue((prev: any) => ({
                                ...prev,
                                searchValue: e.target.value,
                              }))
                            }}
                            style={{ height: "45px" }} // Consistent height across screen sizes
                          />
                          <CiSearch
                            className="position-absolute"
                            style={{
                              top: "10px",
                              right: "30px", // Adjusted for consistent spacing
                              // transform: "translateY(-50%)",
                              color: "#6c757d",
                              cursor: "pointer",
                            }}
                          />
                        </div>

                        <div
                          className=" col-12 col-sm-12 col-md-12  mt-3  col-lg-5 d-flex flex-row  justify-content-end  ms-auto mb-3  "
                          // style={{ backgroundColor: "green" }}
                        >
                          {contacts?.length > 0 && (
                            <div className="d-flex flex-column  gap-3">
                              <div className="d-flex gap-3">
                                <button
                                  className="btn btn   d-flex align-items-center "
                                  style={{
                                    border: "1px solid #20529B",
                                    color: "#20529B",
                                    height: "38px",
                                    width: "180px",
                                  }}
                                  onClick={() => {
                                    navigate(
                                      `/scanned-guests/${Number(event_id)}`,
                                    )
                                  }}
                                >
                                  <MdQrCodeScanner
                                    onClick={() => {
                                      navigate(
                                        `/scanned-guests/${Number(event_id)}`,
                                      )
                                    }}
                                    style={{
                                      color: "#20529B",
                                      marginRight: "8px",
                                      marginLeft: "5px",
                                    }}
                                  />
                                  {t("inviteDetail.scannedGuests")}
                                </button>
                                <button
                                  className="btn btn   d-flex align-items-center "
                                  style={{
                                    border: "1px solid #20529B",
                                    color: "#20529B",
                                    height: "38px",
                                    width: "150px",
                                  }}
                                  onClick={addCard}
                                >
                                  <IoMdAdd
                                    style={{
                                      color: "#20529B",
                                      marginRight: "5px",
                                      marginLeft: "5px",
                                    }}
                                    onClick={addCard}
                                  />
                                  {t("inviteDetail.addGuests")}
                                </button>
                              </div>
                              <div className="d-flex gap-3">
                                {enableSelect ? (
                                  <button
                                    className="btn btn   d-flex align-items-center "
                                    style={{
                                      border: "1px solid #20529B",
                                      color: "#20529B",
                                      height: "38px",
                                      width: "180px",
                                    }}
                                    onClick={() => {
                                      if (selectedContacts.length === 0) {
                                        alert(
                                          "Please select at least one guest",
                                        )
                                      } else {
                                        setShowDownloadInvites(
                                          !showDownloadInvites,
                                        )
                                      }
                                    }}
                                  >
                                    {" "}
                                    <LuDownload
                                      onClick={() => {
                                        if (selectedContacts.length === 0) {
                                          alert(
                                            "Please select at least one guest",
                                          )
                                        } else {
                                          setShowDownloadInvites(
                                            !showDownloadInvites,
                                          )
                                        }
                                      }}
                                      style={{
                                        color: "#20529B",
                                        marginRight: "8px",
                                        marginLeft: "5px",
                                      }}
                                    />
                                    {t("invitation.saveSelected")}
                                  </button>
                                ) : (
                                  <button
                                    className="btn btn   d-flex align-items-center "
                                    style={{
                                      border: "1px solid #20529B",
                                      color: "#20529B",
                                      height: "38px",
                                      width: "180px",
                                    }}
                                    onClick={() =>
                                      setShowDownloadInvites(
                                        !showDownloadInvites,
                                      )
                                    }
                                  >
                                    {" "}
                                    <LuDownload
                                      onClick={() =>
                                        setShowDownloadInvites(
                                          !showDownloadInvites,
                                        )
                                      }
                                      style={{
                                        color: "#20529B",
                                        marginRight: "8px",
                                        marginLeft: "5px",
                                      }}
                                    />
                                    {t("invitation.saveAll")}
                                  </button>
                                )}
                                {enableSelect ? (
                                  <button
                                    className="btn btn   d-flex align-items-center "
                                    style={{
                                      border: "1px solid #20529B",
                                      color: "#20529B",
                                      height: "38px",
                                      width: "150px",
                                    }}
                                    onClick={() =>
                                      setEnableSelect(!enableSelect)
                                    }
                                    // onClick={handleSelectAll}
                                  >
                                    <IoMdClose
                                      onClick={() =>
                                        setEnableSelect(!enableSelect)
                                      }
                                      style={{
                                        color: "#20529B",
                                        marginRight: "8px",
                                        marginLeft: "5px",
                                      }}
                                    />
                                    {t("invitation.cancel")}
                                  </button>
                                ) : (
                                  <button
                                    className="btn btn   d-flex align-items-center "
                                    style={{
                                      border: "1px solid #20529B",
                                      color: "#20529B",
                                      height: "38px",
                                      width: "150px",
                                    }}
                                    onClick={() =>
                                      setEnableSelect(!enableSelect)
                                    }
                                  >
                                    <IoMdCheckmark
                                      onClick={() =>
                                        setEnableSelect(!enableSelect)
                                      }
                                      style={{
                                        color: "#20529B",
                                        marginRight: "8px",
                                        marginLeft: "5px",
                                      }}
                                    />
                                    {t("invitation.select")}
                                  </button>
                                )}
                              </div>
                              <div
                                className="d-flex gap-5 ms-auto"
                                style={{
                                  justifyContent: "flex-end",
                                  marginTop: "5px",
                                }} // Align to the right
                              >
                                {/* {enableSelect ? (
                                  <h6
                                    style={{
                                      color: "#20529B",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      if (selectedContacts.length === 0) {
                                        alert(
                                          "Please select at least one guest",
                                        )
                                      } else {
                                        setShowDownloadInvites(
                                          !showDownloadInvites,
                                        )
                                      }
                                    }}
                                  >
                                    {t("invitation.saveSelected")}
                                  </h6>
                                ) : (
                                  <h6
                                    style={{
                                      color: "#20529B",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      setShowDownloadInvites(
                                        !showDownloadInvites,
                                      )
                                    }
                                  >
                                    {t("invitation.saveAll")}
                                  </h6>
                                )} */}
                                <div></div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {/* )} */}
                  </div>

                  {loading || loadingContacts ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "50vh",
                      }}
                    >
                      <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </div>
                  ) : (
                    <>
                      <div
                        className="d-flex mt-2   gap-2 justify-content-start justify-content-md-start "
                        style={{
                          height: "auto",
                          display: "flex",
                          flexWrap: "wrap",

                          // justifyContent: "center",
                        }}
                      >
                        {contacts?.length === 0 &&
                          contactsValue?.searchValue === "" && (
                            <>
                              {" "}
                              <div
                                className="d-flex justify-content-center w-100 align-items-center "
                                // style={{ color: "white" }}
                              >
                                <div
                                  className="text-center"
                                  // style={{ color: "#000000" }}
                                >
                                  <button
                                    className="btn btn-light mt-3 fs-5"
                                    onClick={addCard}
                                    style={{
                                      backgroundColor: "#245192",
                                      color: "#ffffff",
                                    }}
                                  >
                                    <IoMdAdd
                                      className="mb-1"
                                      style={{
                                        fontSize: "20px",
                                        // marginBottom: "2px",
                                      }}
                                    />{" "}
                                    {t("inviteDetail.addGuests")}
                                  </button>
                                  <div className="mt-5">
                                    <span
                                      className="mb-0   d-block"
                                      style={{ fontSize: "19px" }}
                                    >
                                      {t("inviteDetail.noGuestsYet")}
                                    </span>
                                    <span
                                      className="mb-5 d-block"
                                      style={{ fontSize: "19px" }}
                                    >
                                      {t("inviteDetail.noGuestDescription")}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        {contacts?.length === 0 &&
                          contactsValue?.searchValue != "" && (
                            <>
                              {" "}
                              <div
                                className="d-flex justify-content-center w-100 align-items-center "
                                style={{ height: "200px" }}
                              >
                                {t("inviteDetail.noGuestsFound")}
                              </div>
                            </>
                          )}
                        <div
                          className="d-flex flex-wrap-wrap gap-3"
                          style={{
                            // backgroundColor: "#ffffff",
                            height: "auto",
                            display: "flex",
                            flexWrap: "wrap",
                          }}
                        >
                          {contacts?.length > 0 &&
                            contacts?.map((data: any) => (
                              <>
                                <div
                                  className="shadow-sm m-0"
                                  style={{
                                    height: "230px",
                                    backgroundColor: "#ffffff",
                                    width: "170px",
                                    display: "flex",
                                    flexDirection: "column",
                                    // justifyContent: "center",
                                    alignItems: "center",
                                    paddingLeft: "10px",
                                    paddingRight: "10px",
                                    paddingTop: enableSelect ? "10px" : "20px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleSelectContact(data)} // Handle select when div is clicked
                                >
                                  {data?.status == 4 && !enableSelect && (
                                    <h6 className="d-flex gap-1 align-items-center">
                                      {" "}
                                      <IoMdCheckmark
                                        style={{ fontSize: "19px" }}
                                      />{" "}
                                      <span style={{ fontSize: "14px" }}>
                                        {" "}
                                        {t("invitation.scanned")}
                                      </span>
                                    </h6>
                                  )}
                                  {enableSelect && (
                                    <div className="ms-auto">
                                      {" "}
                                      <input
                                        type="checkbox"
                                        checked={selectedContacts.some(
                                          (contact: any) =>
                                            contact.id === data.id,
                                        )} // Check if this contact is selected
                                        onChange={(event: any) => {
                                          handleSelectContact(data) // Pass the whole contact object
                                        }}
                                        onClick={(event) =>
                                          event.stopPropagation()
                                        } // Prevent parent div click
                                        style={{
                                          // position: "absolute",
                                          top: "10px",
                                          right: "10px",
                                          width: "18px",
                                          height: "18px",
                                          borderRadius: "50%",
                                          color: "grey",
                                          cursor: "pointer",
                                        }}
                                      />
                                    </div>
                                  )}

                                  <div
                                    style={{
                                      position: "relative", // Position context for the image and edit icon
                                      width: "110px", // Width same as the image size
                                      height: "110px", // Height same as the image size
                                      borderRadius: "50%",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <img
                                      onClick={() => {
                                        handleDisplayImage(data)
                                      }}
                                      src={qrCodeData?.image_url}
                                      style={{
                                        height: "110px", // Set image height
                                        width: "110px", // Set image width
                                        borderRadius: "50%", // Circular image
                                        display: "block", // Ensures the image is displayed as a block
                                        objectFit: "contain", // Keeps the image's aspect ratio intact
                                        position: "absolute", // Position image inside the div
                                        top: "0", // Position image inside the div
                                        left: "50%", // Center the image horizontally
                                        transform: "translateX(-50%)", // Center the image correctly
                                        backgroundColor: "#c4c4c4",
                                        cursor: "pointer",
                                      }}
                                    />

                                    {/* Edit Icon positioned to overlap half of the image and half below it */}
                                    <div
                                      style={{
                                        position: "absolute", // Position it relative to the parent div
                                        bottom: "-20px", // Moves the icon down by half of the icon's height (-15px)
                                        left: "50%", // Center horizontally
                                        transform: "translateX(-50%)", // Center the icon correctly
                                        borderRadius: "50%",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {!enableSelect && (
                                        <div
                                          style={{
                                            textDecoration: "none",
                                            backgroundColor: "#4CB050", // Green background for the edit icon
                                            width: "40px", // Width of the edit icon
                                            height: "40px", // Height of the edit icon
                                            borderRadius: "50%", // Circular edit icon
                                            display: "flex", // Use flexbox to center the icon inside the circle
                                            justifyContent: "center", // Center the icon horizontally
                                            alignItems: "center", // Center the icon vertically
                                            padding: "9px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <MdEdit
                                            style={{ color: "white" }}
                                            onClick={() =>
                                              handleEditContact(data)
                                            }
                                          />{" "}
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  <div className="d-flex flex-row  gap-1 mb-0 mt-4">
                                    <h5 style={{ fontSize: "1rem" }}>
                                      {data?.first_name}
                                    </h5>
                                  </div>

                                  <div
                                    className="mt-2 d-flex flex-row justify-content-between w-100 ps-1 pe-1"
                                    // style={{ backgroundColor: "red" }}
                                  >
                                    <button
                                      onClick={() => {
                                        handleDownLoadSingle(data)
                                      }}
                                      style={{
                                        backgroundColor: "transparent",
                                        color: "#245192",
                                        fontSize: "14px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: "8px 10px",
                                        borderRadius: "10px",
                                        textDecoration: "none",
                                        cursor: "pointer",
                                        fontFamily: "Inter",
                                        border: "none",
                                      }}
                                    >
                                      <LuDownload
                                        style={{
                                          fontSize: "20px",
                                          marginRight: "5px",
                                        }}
                                      />
                                    </button>

                                    <div
                                      style={{
                                        // backgroundColor: "#EE1919",
                                        borderRadius: "50%",
                                        height: "37px",
                                        width: "37px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        padding: "9px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <RiDeleteBin6Line
                                        style={{ color: "red" }}
                                        onClick={() =>
                                          handleDeleteContact(data)
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </>
                            ))}
                        </div>
                      </div>
                      <div className="mt-5">
                        <PaginationControl
                          page={contactsValue?.currentPage}
                          total={contactsValue?.totalPages}
                          between={3}
                          limit={1}
                          ellipsis={1}
                          changePage={(page) => {
                            onPageChanged(page)
                          }}
                        />
                      </div>
                    </>
                  )}
                </div>
              </>
            ) : (
              <div
                className="d-flex flex-column gap-2 align-items-center justify-content-center"
                style={{ height: "40vh" }}
              >
                <div className="alert alert-danger fs-5" role="alert">
                  Event not found with this Id ={event_id}
                </div>
                <Link
                  className="d-flex align-items-center "
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    color: "black",
                    fontSize: "18px",
                    textDecoration: "none",
                    textTransform: "none",
                  }}
                  to="/"
                >
                  <button
                    // onClick={(e) => onSubmit(e, "")}
                    className="btn btn-dark w-100"
                    style={{
                      height: "40px",
                      borderRadius: "5px",
                      backgroundColor: "#20529B",
                      border: "none",
                    }} // Ensure it sticks to the bottom
                  >
                    Back To Home
                  </button>
                </Link>
              </div>
            )}

            {subscription != "pro_plan" && subscription != "unlimited_plan" && (
              <>
                {showPremium && (
                  <div
                    style={{
                      margin: "10px",
                      position: "fixed",
                      bottom: "0", // Aligns it to the bottom
                      right: "0", // Aligns it to the right
                      width: "auto", // Adjust as needed, or remove for automatic width
                      zIndex: "1000", // Ensures it's above other content
                      // padding: "20px", // Optional padding for spacing
                      // backgroundColor: "#f8f9fa", // Optional background color
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    {premium == 1 ? (
                      <>
                        <div
                          className="d-flex shadow-md rounded-3 p-4 me-0 mb-4 ms-0 flex-column align-items-start"
                          style={{
                            maxWidth: "400px",
                            backgroundColor: "#ffffff", // Fixed typo
                            gap: "20px", // Adds spacing between child elements
                          }}
                        >
                          <div className="w-100 d-flex flex-row gap-2 align-items-center">
                            <BsFillPatchCheckFill
                              style={{
                                color: "#245192",
                              }}
                            />
                            <h5 className="mb-1" style={{ fontSize: "20px" }}>
                              {t("inviteDetail.premiumEvent")}{" "}
                            </h5>
                            <div
                              className="ms-auto" // Bootstrap class to push the icon to the end
                              style={{ cursor: "pointer", marginTop: "-10px" }}
                            >
                              <IoMdClose
                                size={20}
                                onClick={() => setShowPremium(!showPremium)}
                              />
                            </div>
                          </div>

                          <h5 style={{ fontSize: "15px" }}>
                            {t(
                              "inviteDetail.enjoyFullAccessToAllFeaturesAtNoExtraCost",
                            )}
                          </h5>
                        </div>
                      </>
                    ) : (
                      <div
                        className="d-flex shadow-md rounded-3 p-4 me-0 mb-4 ms-0 flex-row align-items-start"
                        style={{
                          maxWidth: "450px",
                          backgroundColor: "#ffffff", // Fixed typo
                          gap: "20px", // Adds spacing between child elements
                        }}
                      >
                        {/* Small Icon/Image */}
                        <img
                          src={invitesmart}
                          alt="Invite Smart Icon"
                          style={{
                            height: "40px",
                            width: "40px",
                            objectFit: "contain",
                          }}
                        />

                        {/* Main Content */}
                        <div
                          className="flex-grow-1 "
                          style={{ textAlign: "left" }}
                        >
                          <h5
                            className="fw-bold mb-2"
                            style={{ fontSize: "19px" }}
                          >
                            {t("inviteDetail.upgradeToPremiumForJustSar49")}
                          </h5>
                          <h5
                            className="mb-3 text-muted"
                            style={{ fontSize: "15px" }}
                          >
                            {t(
                              "inviteDetail.getPremiumAccessNowAndUnlockExclusiveFeaturesAndElevateYourEvent",
                            )}
                          </h5>
                          <button
                            className="btn btn-light mt-0 w-100"
                            style={{
                              backgroundColor: "#245192",
                              color: "#ffffff",
                              fontSize: "15px",
                              top: "0px",
                            }}
                            onClick={handleSaveInvite}
                            disabled={loadingPremium}
                          >
                            {loadingPremium ? (
                              <div className="d-flex justify-content-center align-items-center">
                                <Spinner animation="border" role="status">
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </Spinner>
                              </div>
                            ) : (
                              <span>{t("inviteDetail.upgradeToPremium")}</span>
                            )}
                          </button>
                        </div>

                        {/* Close Icon */}
                        <div style={{ cursor: "pointer", marginTop: "-10px" }}>
                          <IoMdClose
                            size={20}
                            onClick={() => setShowPremium(!showPremium)}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
      {/* upgrade  */}
      <Modal show={showUpdateModal} onHide={handleCloseUpdateModal} centered>
        <Modal.Header
          closeButton
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "20px",
          }}
        >
          {" "}
        </Modal.Header>

        <Modal.Body
          style={{
            marginTop: "-100px",
            // backgroundColor: "red"
          }}
          className=" w-100  m-0 d-flex flex-column justify-content-center align-items-center gap-0"
        >
          <div
            className="ps-5 pe-5  m-0 w-100"
            style={{
              width: "300px",
              height: "250px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            <div className="d-flex flex-column gap-3 ">
              <Button
                className="d-flex mt-3 "
                style={{ backgroundColor: "#20529B", color: "#ffffff" }}
              >
                {" "}
                {t("buttons.upgradeInvitationToPremium")}
              </Button>
              <Button
                className="d-flex "
                style={{ backgroundColor: "#20529B", color: "#ffffff" }}
              >
                {t("buttons.chooseASubscriptionPlan")}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* add guests */}
      <Modal show={showCreateModal} onHide={handleCloseCreateModal} centered>
        <Modal.Body className=" w-100  m-0 d-flex flex-column justify-content-center align-items-center gap-0">
          <div
            className="ps-5 pe-5 pb-2   m-0 w-100 "
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              minHeight: "300px",
              minWidth: "100px",
              // backgroundColor: "green",
              // padding: "0px",
            }}
          >
            {/* currentAddTye,  */}
            {currentAddTye == "name" ? (
              <div>
                <form
                  className="d-flex flex-column p-3"
                  onSubmit={handleSubmitFormNaming}
                >
                  <div className=" d-flex justify-content-center">
                    <h5 className="mb-1 fs-3 fw-bold">
                      {/* {t("invitation.addNames")} */}
                      {/* Add Names */}
                      {t("inviteDetail.addNames")}
                    </h5>{" "}
                  </div>
                  <div className="d-flex flex-column justify-content-center align-items-center mt-2 mb-2 ">
                    <h5
                      style={{
                        position: "relative",
                        paddingBottom: "8px", // Adjust for spacing between text and underline
                      }}
                      className="mb-2 pb-2 "
                    >
                      <span className="me-1">{t("invitation.please")}</span>
                      <span className="me-1" style={{ color: "#20529B" }}>
                        {t("invitation.add")}
                      </span>
                      <span className="me-1"> {t("invitation.nameOr")}</span>
                      <span style={{ color: "#20529B" }} className="me-1">
                        {t("invitation.paste")}
                      </span>
                      {t("invitation.themHereSeparateEachGuestNameWithAComma")}
                    </h5>
                    <div
                      className="profile-input mt-2 rounded-sm text-dark d-flex -justify-content-center "
                      style={{ width: "85%" }}
                    >
                      <style>
                        {`
         input::placeholder {
        color: #d3d2d2;
          
               }
             `}
                      </style>
                      <textarea
                        required
                        placeholder={t("invitation.addGuestName")}
                        value={namesInput}
                        onChange={(e) => setNamesInput(e.target.value)}
                        style={{
                          color: "#000000", // Text color
                          fontSize: "1rem",
                          paddingLeft: "20px",
                          paddingRight: "10px",
                          backgroundColor: "white",
                          borderRadius: "10px",
                          paddingTop: "20px",
                          paddingBottom: "7px",
                          border: "1px solid #ccc", // Optional: border styling
                          width: "100%",
                          resize: "vertical",
                          //   height: "100px", // Adjust height as needed
                        }}
                        rows={5} // Optional: Controls the default number of rows
                      />
                    </div>
                  </div>
                  <div className="d-flex flex-column align-items-center justify-content-center gap-1">
                    <button
                      type="submit"
                      className="w-100 btn btn-dark d-flex align-items-center justify-content-center"
                      style={{
                        width: "150px",
                        height: "40px",
                        borderRadius: "5px",
                        backgroundColor: "#20529B",
                        border: "none",
                      }}
                      disabled={addingGuestLoading}
                    >
                      {t("buttons.addGuests")}
                    </button>

                    {/* Center the "Or" text */}
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ width: "100%" }}
                    >
                      <span style={{ fontFamily: "Roboto" }}>Or</span>
                    </div>

                    <button
                      className="w-100 btn btn-dark d-flex align-items-center justify-content-center"
                      style={{
                        width: "150px",
                        backgroundColor: "#ffffff",

                        // backgroundColor: "green",
                        // height: "40px",
                        borderRadius: "5px",
                        border: "1px solid black",
                        // marginTop: "20px",
                        color: "black",
                      }}
                      onClick={() => {
                        setCurrentAddType("number")
                      }}
                      disabled={addingGuestLoading}
                    >
                      {t("invitation.generateGuestWithNumber")}
                    </button>
                  </div>
                </form>
              </div>
            ) : (
              <div>
                <Link
                  className="d-flex align-items-center reminders-page__link-container"
                  to="#"
                  onClick={() => {
                    setCurrentAddType("name")
                  }}
                >
                  <IconArrowLeft />
                  <span className="reminders-page__link-text">
                    {t("buttons.backNew")}
                  </span>
                </Link>
                <form
                  className="d-flex flex-column gap-4 align-items-center justify-content-center"
                  onSubmit={handleSubmitFormNumber}
                >
                  <h5 className=" fs-3 fw-bold">
                    {t("inviteDetail.addGuests")}
                  </h5>{" "}
                  <h5
                    style={{
                      position: "relative",
                      paddingBottom: "8px", // Adjust for spacing between text and underline
                    }}
                  >
                    {t("inviteDetail.howManyGuestsYouWantToAdd")}
                  </h5>
                  <input
                    type="number"
                    value={numberOfGuests}
                    onChange={(e: any) =>
                      setNumberOfGuests(Math.max(1, Number(e.target.value)))
                    }
                    className="form-control"
                    min={1}
                    style={{ width: "230px" }}
                    placeholder="Number of Guests"
                    required
                  />{" "}
                  <button
                    type="submit"
                    // onClick={(e) => onSubmit(e, "")}
                    className="btn btn-dark w-100"
                    style={{
                      height: "40px",
                      borderRadius: "5px",
                      backgroundColor: "#20529B",
                      border: "none",
                    }} // Ensure it sticks to the bottom
                    disabled={addingGuestLoading}
                  >
                    {/* {addingGuestLoading ? (
                      <h6 className="p-1">loading...</h6>
                    ) : (
                      t("buttons.addGuests")
                    )} */}
                    {t("buttons.addGuests")}
                  </button>
                </form>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
      {/* edit contant  */}
      <Modal show={showEditContact} onHide={handleCloseEditContact} centered>
        <Modal.Body
          style={{
            marginTop: "-100px",
            // backgroundColor: "red"
          }}
          className=" w-100  m-0 d-flex flex-column justify-content-center align-items-center gap-0"
        >
          <div
            className="ps-5 pe-5 pb-2   m-0 w-100"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              minHeight: "300px",
              minWidth: "100px",
            }}
          >
            <div>
              <form
                className="d-flex flex-column gap-4 align-items-center justify-content-center"
                onSubmit={handleSubmitEdit}
              >
                <h5 className=" fs-3 fw-bold">{t("inviteDetail.editGuest")}</h5>{" "}
                <input
                  type="text"
                  value={guestEdit}
                  // onChange={(e: any) => setGuestEdit(e.target.value)}
                  onChange={(e: any) => {
                    const value = e.target.value
                    // Allow only letters (uppercase and lowercase) and spaces
                    // const textOnly = value.replace(/[^a-zA-Z\s]/g, "")
                    // setGuestEdit(textOnly)
                    setGuestEdit(value)
                  }}
                  // min={1}
                  className="form-control"
                  style={{ width: "300px" }}
                  placeholder="Edit  of Guests"
                />{" "}
                <div className="d-flex justify-content-space-between gap-3 mt-3 ">
                  <button
                    // onClick={(e) => onSubmit(e, "")}
                    type="button" // Prevent form submission
                    className="btn btn-dark  "
                    style={{
                      width: "130px",
                      height: "40px",
                      borderRadius: "5px",
                      backgroundColor: "white",
                      border: "1ps solid grey",
                      color: "black",
                    }} // Ensure it sticks to the bottom
                    onClick={handleCloseEditContact}
                  >
                    {t("buttons.cancel")}
                  </button>
                  <button
                    type="submit"
                    // onClick={(e) => onSubmit(e, "")}
                    className="btn btn-dark "
                    style={{
                      width: "130px",
                      height: "40px",
                      borderRadius: "5px",
                      backgroundColor: "#20529B",
                      border: "none",
                    }} // Ensure it sticks to the bottom
                    disabled={loadingEditGuest}
                  >
                    {loadingEditGuest ? (
                      <h6 className="mt-1">editing...</h6>
                    ) : (
                      t("inviteDetail.editGuest")
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* delete and contact */}
      <Modal
        show={showDeleteContact}
        onHide={handleCloseDeleteContact}
        centered
      >
        <Modal.Body
          style={{
            marginTop: "-100px",
            // backgroundColor: "red"
          }}
          className=" w-100  m-0 d-flex flex-column justify-content-center align-items-center gap-0"
        >
          <div
            className="ps-5 pe-5 pb-2   m-0 w-100"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              minHeight: "300px",
              minWidth: "100px",
            }}
          >
            <div className="d-flex flex-column gap-4 align-items-center justify-content-center">
              {/* <form
                className="d-flex flex-column gap-4 align-items-center justify-content-center"
                onSubmit={handleSubmitDeleteContact}
              > */}
              <h5 className=" fs-3 fw-bold">{t("inviteDetail.areYouSure")}</h5>{" "}
              <h5
                className="d-flex flex-wrap"
                style={{
                  position: "relative",
                  paddingBottom: "8px", // Adjust for spacing between text and underline
                }}
              >
                {t("inviteDetail.deleteGuestInfo")}
              </h5>
              <div className="d-flex justify-content-space-between gap-4 ">
                <button
                  // onClick={(e) => onSubmit(e, "")}
                  className="btn btn-dark w-100 "
                  style={{
                    height: "40px",
                    borderRadius: "5px",
                    backgroundColor: "white",
                    border: "1ps solid grey",
                    color: "black",
                  }} // Ensure it sticks to the bottom
                  onClick={handleCloseDeleteContact}
                >
                  {t("buttons.cancel")}
                </button>
                <button
                  type="submit"
                  // onClick={(e) => onSubmit(e, "")}
                  className="btn btn-dark  w-100"
                  style={{
                    height: "40px",
                    borderRadius: "5px",
                    backgroundColor: "#20529B",
                    border: "none",
                  }} // Ensure it sticks to the bottom
                  disabled={loadingDeleteContact}
                  onClick={handleSubmitDeleteContact}
                >
                  {loadingDeleteContact ? (
                    <h6 className="mt-1">deleting ...</h6>
                  ) : (
                    t("buttons.delete")
                  )}
                </button>
              </div>
              {/* </form> */}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* delete event/ */}
      <Modal show={showDeleteEvent} onHide={handleCloseDeleteEvent} centered>
        <Modal.Body
          style={{
            marginTop: "-100px",
            // backgroundColor: "red"
          }}
          className=" w-100  m-0 d-flex flex-column justify-content-center align-items-center gap-0"
        >
          <div
            className="ps-5 pe-5 pb-2   m-0 w-100"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              minHeight: "300px",
              minWidth: "100px",
            }}
          >
            <div className="d-flex flex-column gap-4 align-items-center justify-content-center">
              {/* <form
                className="d-flex flex-column gap-4 align-items-center justify-content-center"
                onSubmit={handleSubmitDeleteContact}
              > */}
              <h5 className=" fs-3 fw-bold">
                {/* {t("invitation.addNames")} */}
                {t("inviteDetail.areYouSure")}
              </h5>{" "}
              <h5
                style={{
                  position: "relative",
                  paddingBottom: "8px", // Adjust for spacing between text and underline
                }}
              >
                {t("inviteDetail.youAreAboutToDeleteAnInvite")}
              </h5>
              <div className="d-flex justify-content-space-between gap-4 ">
                <button
                  // onClick={(e) => onSubmit(e, "")}
                  className="btn btn-dark w-100 "
                  style={{
                    height: "40px",
                    borderRadius: "5px",
                    backgroundColor: "white",
                    border: "1ps solid grey",
                    color: "black",
                  }} // Ensure it sticks to the bottom
                  onClick={handleCloseDeleteEvent}
                >
                  {t("buttons.cancel")}
                </button>
                <button
                  type="submit"
                  // onClick={(e) => onSubmit(e, "")}
                  className="btn btn-dark  w-100"
                  style={{
                    height: "40px",
                    borderRadius: "5px",
                    backgroundColor: "#20529B",
                    border: "none",
                  }} // Ensure it sticks to the bottom
                  disabled={loadingDeleteEvent}
                  onClick={handleSubmitDeleteEvent}
                >
                  {loadingDeleteEvent ? (
                    <h6 className="mt-1">deleting ...</h6>
                  ) : (
                    t("buttons.delete")
                  )}
                </button>
              </div>
              {/* </form> */}
            </div>
          </div>
          {/* <ToastContainer
            style={{ width: "90%", maxWidth: "400px", fontSize: "18px" }}
          /> */}
        </Modal.Body>
      </Modal>
      {/* dwonload mukltipel images fixed  */}
      <Modal
        show={showDownloadInvites}
        onHide={handleCloseDownloadInvites}
        centered
        className="d-none d-md-block"
      >
        <Modal.Body className=" w-100  m-0 d-flex flex-column justify-content-center align-items-center gap-0">
          <div
            className="ps-5 pe-5 pb-2  pt-3 pb-3  m-0 "
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              minHeight: "300px",
              minWidth: "100px",
            }}
          >
            {/* <div className="w-100 d-none d-sm-block "> */}
            <DownloadAllImages
              nameOrNumberArray={enableSelect ? selectedContacts : contacts} // Example numbers
              event={event}
              setShowDownloadInvites={setShowDownloadInvites}
              qrCodeData={qrCodeData}
            />
            {/* </div> */}
            {/* <div className="w-100 d-block d-sm-none ">
              <DownloadAllImagesSmaller
                nameOrNumberArray={enableSelect ? selectedContacts : contacts} // Example numbers
                event={event}
                setShowDownloadInvites={setShowDownloadInvites}
                qrCodeData={qrCodeData}
              />
            </div> */}
          </div>
        </Modal.Body>
      </Modal>
      {/* mobikle mukltple image doanload */}
      <Modal
        show={showDownloadInvites}
        onHide={handleCloseDownloadInvites}
        centered
        className="d-block d-md-none"
        fullWidth
        dialogClassName="modal-fullscreen" // Apply fullscreen class
      >
        <Modal.Body className=" w-100  m-0 d-flex flex-column justify-content-center align-items-center gap-0">
          <div>
            <button className="btn btn" onClick={handleCloseDownloadInvites}>
              <IoIosClose onClick={handleCloseDownloadInvites} />
              Close
            </button>
          </div>
          <div
            className="ps-5 pe-5 pb-2  pt-3 pb-3  m-0 "
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              minHeight: "300px",
              minWidth: "100px",
            }}
          >
            {/* <div className="w-100 d-none d-sm-block "> */}
            <DownloadAllImages
              nameOrNumberArray={enableSelect ? selectedContacts : contacts} // Example numbers
              event={event}
              setShowDownloadInvites={setShowDownloadInvites}
              qrCodeData={qrCodeData}
            />
            {/* </div> */}
            {/* <div className="w-100 d-block d-sm-none ">
              <DownloadAllImagesSmaller
                nameOrNumberArray={enableSelect ? selectedContacts : contacts} // Example numbers
                event={event}
                setShowDownloadInvites={setShowDownloadInvites}
                qrCodeData={qrCodeData}
              />
            </div> */}
          </div>
        </Modal.Body>
      </Modal>
      {/* image display  modal */}
      <Modal
        className="d-none d-md-block"
        show={displayImage}
        onHide={handleCloseDisplayImage}
        centered
        // fullWidth
        // dialogClassName="modal-fullscreen" // Apply fullscreen class
        // className=""
        // style={{ all: "unset" }} // Disable all inherited styles for the modal itself
      >
        {/* <Modal.Header className="d-flex fled-row justifyContent">
          {" "}
        </Modal.Header> */}
        <Modal.Body className=" ms-0 me-0  mt-1 mb-1 w-100  m-0 d-flex flex-column justify-content-center align-items-center gap-0">
          <div
            className="m-0 p-0 "
            // style={{ minHeight: "300px", }}
          >
            {" "}
            {/* <div className="w-100 d-none d-sm-block "> */}
            <ResponsiveImageWithQRCode
              currentContact={currentContact}
              event={event}
              qrCodeData={qrCodeData}
              setDisplayImage={setDisplayImage}
            />
            {/* </div> */}
            {/* <div className="w-100 d-block d-sm-none">
              <ResponsiveImageWithQRCodeSmaller
                currentContact={currentContact}
                event={event}
                qrCodeData={qrCodeData}
                setDisplayImage={setDisplayImage}
              />
            </div> */}
          </div>
        </Modal.Body>
      </Modal>
      {/* mobile image display */}
      <Modal
        show={displayImage}
        onHide={handleCloseDisplayImage}
        centered
        className="d-block d-md-none"
        fullWidth
        dialogClassName="modal-fullscreen" // Apply fullscreen class
        // className=""
        // style={{ all: "unset" }} // Disable all inherited styles for the modal itself
      >
        {/* <Modal.Header className="d-flex fled-row justifyContent">
          {" "}
        </Modal.Header> */}
        <Modal.Body className=" ms-0 me-0  mt-1 mb-1 w-100  m-0 d-flex flex-column justify-content-center align-items-center gap-0">
          <div>
            <button className="btn btn" onClick={handleCloseDisplayImage}>
              <IoIosClose onClick={handleCloseDisplayImage} />
              Close
            </button>
          </div>
          <div
            className="m-0 p-0 "
            // style={{ minHeight: "300px", }}
          >
            {" "}
            {/* <div className="w-100 d-none d-sm-block "> */}
            <ResponsiveImageWithQRCode
              currentContact={currentContact}
              event={event}
              qrCodeData={qrCodeData}
              setDisplayImage={setDisplayImage}
            />
            {/* </div> */}
            {/* <div className="w-100 d-block d-sm-none">
              <ResponsiveImageWithQRCodeSmaller
                currentContact={currentContact}
                event={event}
                qrCodeData={qrCodeData}
                setDisplayImage={setDisplayImage}
              />
            </div> */}
          </div>
        </Modal.Body>
      </Modal>{" "}
      {/* download single image  modal*/}
      <Modal
        show={showDownloadInvitesSingle}
        onHide={handleCloseDownloadInvitesSingle}
        centered
        className="d-block d-md-none"
        fullWidth
        dialogClassName="modal-fullscreen" // Apply fullscreen class
      >
        <Modal.Body
          style={
            {
              // marginTop: "-100px",
              // backgroundColor: "red"
            }
          }
          className=" w-100  m-0 d-flex flex-column justify-content-center align-items-center gap-0"
        >
          <div>
            <button
              className="btn btn"
              onClick={handleCloseDownloadInvitesSingle}
            >
              <IoIosClose onClick={handleCloseDownloadInvitesSingle} />
              Close
            </button>
          </div>
          <div
            className="ps-5 pe-5 pb-2  pt-3 pb-3  m-0 "
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              minHeight: "300px",
              minWidth: "100px",
            }}
          >
            {/* <div className="w-100 d-none d-sm-block "> */}
            <DownloadSingleImage
              nameOrNumberArray={
                currentContactSingle ? currentContactSingle : []
              } // Example numbers
              event={event}
              setShowDownloadInvites={setShowDownloadInvites}
              qrCodeData={qrCodeData}
            />
            {/* </div> */}
            {/* <div className="w-100 d-block d-sm-none ">
              <DownloadSingleImageSmaller
                // ref={downloadRef}
                nameOrNumberArray={
                  currentContactSingle ? currentContactSingle : []
                } // Example numbers
                event={event}
                setShowDownloadInvites={setShowDownloadInvites}
                qrCodeData={qrCodeData}
              />
            </div> */}
          </div>
        </Modal.Body>
      </Modal>
      {/* donwload single image */}
      <Modal
        show={showDownloadInvitesSingle}
        onHide={handleCloseDownloadInvitesSingle}
        centered
        className="d-none d-md-block"
      >
        <Modal.Body
          style={
            {
              // marginTop: "-100px",
              // backgroundColor: "red"
            }
          }
          className=" w-100  m-0 d-flex flex-column justify-content-center align-items-center gap-0"
        >
          <div
            className="ps-5 pe-5 pb-2  pt-3 pb-3  m-0 "
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              minHeight: "300px",
              minWidth: "100px",
            }}
          >
            {/* <div className="w-100 d-none d-sm-block "> */}
            <DownloadSingleImage
              nameOrNumberArray={
                currentContactSingle ? currentContactSingle : []
              } // Example numbers
              event={event}
              setShowDownloadInvites={setShowDownloadInvites}
              qrCodeData={qrCodeData}
            />
            {/* </div> */}
            {/* <div className="w-100 d-block d-sm-none ">
              <DownloadSingleImageSmaller
                // ref={downloadRef}
                nameOrNumberArray={
                  currentContactSingle ? currentContactSingle : []
                } // Example numbers
                event={event}
                setShowDownloadInvites={setShowDownloadInvites}
                qrCodeData={qrCodeData}
              />
            </div> */}
          </div>
        </Modal.Body>
      </Modal>
      {/* <ToastContainer
        style={{ width: "90%", maxWidth: "400px", fontSize: "18px" }}
      /> */}
    </div>
  )
}

export default InviteDetail
